var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmtpServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 25.846,
    y1: 25.846,
    x2: 44.929,
    x1: 9.25,
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f7ab40",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f4a73c",
    offset: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ed992f",
    offset: 0.671
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e2861d",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 44.356,
    y1: 6.948,
    x2: 26.58,
    x1: 5.988,
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#eba84b",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d97218",
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#c5c5c5",
      fillOpacity: 1
    },
    d: "M29.612 14.333h86v143.334h-86Z",
    transform: "scale(.27907)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9e9e9e",
      fillOpacity: 1
    },
    d: "M36.778 21.5h71.667v14.333H36.778Zm0 21.5h71.667v14.333H36.778Zm0 21.5h71.667v14.333H36.778Z",
    transform: "scale(.27907)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#76ff03"
    },
    d: "M97.695 25.083a3.583 3.583 0 1 0 0 7.167 3.583 3.583 0 0 0 0-7.167zm0 21.5a3.583 3.583 0 1 0 0 7.167 3.583 3.583 0 0 0 0-7.167zm0 21.5a3.583 3.583 0 1 0 0 7.167 3.583 3.583 0 0 0 0-7.167z",
    transform: "scale(.27907)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#a)"
    },
    d: "m9 26 36-14.308V38a2 2 0 0 1-2 2H9Z",
    fill: "url(#a)",
    transform: "translate(24.324 23.857) scale(.47619)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#b)"
    },
    d: "M3 11.692V38a2 2 0 0 0 2 2h38a1.98 1.98 0 0 0 1.283-.478z",
    fill: "url(#b)",
    transform: "translate(24.324 23.857) scale(.47619)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M25.753 29.095h20v.806l-8.248 6.404a2.857 2.857 0 0 1-3.505 0l-8.247-6.404Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M25.753 28.857h20v.806l-8.588 6.243a2.375 2.375 0 0 1-2.825 0l-8.587-6.243Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.705 27.666H44.8c.526 0 .953.427.953.953v.806l-8.928 6.082a1.904 1.904 0 0 1-2.145 0l-8.927-6.082v-.806c0-.526.426-.953.952-.953Z",
    fill: "#fabb62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmtpServer);
export default __webpack_public_path__ + "static/media/smtpServer.e90b5db3ec04148004f4336e01417856.svg";
export { ForwardRef as ReactComponent };